import App from './main';
import { authorizationReducer as authorization } from './auth';
import { navigationReducer as navigation, layoutReducer as layout } from './layout';

export default App;

export const reducers = { authorization, navigation, layout };
